import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import { roledrp } from '../../Helper'
import moment from 'moment'
import {BsSearch} from 'react-icons/bs'
import { menumgmtApi,menumgmtmodelApi } from '../../../utils/AdminDashApi/MenuMgmtApi'
import { roleMgmtApi } from '../../../utils/AdminDashApi/RoleMgmtApi'
import { menuApi } from '../../../utils/AdminDashApi/MenuApi'
import { empwiseattApi } from '../../../utils/AdminDashApi/EmpWiseAttApi'
import MobileInputSubComp from './sub_components/MobileInputSubComp'
const EmployeeWiseAttendanceCompmb = () => {
    const [activefrom,setactivefrom] = useState("")
    const [activeto,setactiveTo] = useState("")
    const [activefrommdl,setactivefrommdl] = useState("")
    const [activefrommdlnm,setactivefrommdlnm] = useState("")
    const [activetomdl,setactiveTomdl] = useState("")
    const [activetomdlnm,setactiveTomdlnm] = useState("")
    const [show,setShow] = useState(10)
    const [show2,setShow2] = useState("")
    
   
    const [roleDrp,setRoledrp] = useState("")
    const handleShow = () => setShow2(true);
   
    const optionsShowt = [
      {
        id:0,
        opt:"Select"
      }
      ,{
        id:1,
        opt:10
      },
      {
        id:2,
        opt:20
      },
      {
        id:3,
        opt:30
      },
    ]
    const [mainpagesearch,setmainpagesearch] = useState("")
    const handlemainpagesearch=(e)=>{
      setmainpagesearch(e.target.value)
    }
    const [statusvalueerr,setstatusvalueerr] = useState("")
    const [activefromMoment,setactivefromMoment] = useState("")
  
    useEffect(()=>{
      var date = moment("2017-07-11")
        var now = moment("2020-07-12");
  
        if (now > date) {
          console.log("past")
        } else {
          console.log("future")
        }
    },[])
    
      const handleActiveFrom = (activefromval)=>{
  
          if(activefromval != null){
            
              var dtmnt = activefromval.$M + 1;
              var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
             
              var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
              console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
              console.log(dtfinalc)
              setactivefrommdl(dtfinalc)
          }
          
          
      }
        const handleActiveTo = (activetoval)=>{
      
          if(activetoval != null){
      
              var dtmnt = activetoval.$M + 1;
              var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
              var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
              setactiveTomdl(dtfinalc)
  
              
          }
          
          
      }
     
   
  
      const [show3, setShow3] = useState(false);
      const [modalitem,setmodalitem] = useState({})
      
    const [currentItems, setCurrentItems] = useState([]);
    const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    const [pageCountfiltered, setPageCountfiltered] = useState(0);
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);
    const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
    const [itemsPerPage,setitemsPerPage] = useState(10);
    const [paginatenumselected,setpaginatenumselected] = useState(0)
    const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
    const [pageCount2, setPageCount2] = useState(0);
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset2, setItemOffset2] = useState(0);
    const [itemsPerPage2,setitemsPerPage2] = useState(10);
    
    const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
    const [paginatenumselected2,setpaginatenumselected2] = useState(0)
    const [filteredArr,setfilteredArr] = useState(empwiseattApi.data)
  
  
  
    const mainfilter=(searchkey,myactivefromdate,myactivetodate,arr)=>{    
      
      let filteredArr = [];
  
  if (searchkey) {
    filteredArr = arr.filter((item) => {
      
      const searchMatch = item.userid.toString().includes(searchkey);
      return searchMatch;
    });
  } else  {
    filteredArr = arr.filter((item) => {
      return item;
    });
  }
  
  setfilteredArr(filteredArr);
      
    }
  
  
  
    const [tempfilteredarr,settempfilteredarr] = useState([])
      useEffect(() => {
          // Fetch items from another resources.
          const endOffset = itemOffset + itemsPerPage;        
          setCurrentItems(empwiseattApi.data.slice(itemOffset, endOffset));        
          setPageCount(Math.ceil(empwiseattApi.data.length / itemsPerPage));
          
        }, [itemOffset, itemsPerPage,currentItems]);
        let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
        useEffect(()=>{
          const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
          settempfilteredarr(filteredArr.slice(itemOffsetfiltered, endOffsetfiltered));
          setPageCountfiltered(Math.ceil(pagecountoffilter / itemsPerPagefiltered));
          setpagecountoffilter(filteredArr.length)
        },[itemOffsetfiltered,itemsPerPagefiltered,filteredArr,tempfilteredarr])
      
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
          const newOffset = event.selected * itemsPerPage % empwiseattApi.data.length;        
          setpaginatenumselected(event.selected);
          setItemOffset(newOffset);
        };
        const handlePageClickfiltered = (event) => {
          const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
          setpaginatenumselectedfiltered(event.selected);
          setItemOffsetfiltered(newOffsetf);
        };
      
        
      const [idsave,setidsave]=useState(false)
      
  
  
      
  
      const [searchinputmodal,setsearchinputmodal] = useState("")
      const [rolesearchkey,setrolesearchkey] = useState("")
      const handlesearchinputmodal=(e)=>{
        setsearchinputmodal(e.target.value)      
      }
      const handlesearchmodal=()=>{
        setrolesearchkey(searchinputmodal)
      }
      const drpfuncshow=(myshow,id)=>{
        setShow(myshow)
        
      }
      
      const [ischkmodal,setischkmodal] = useState(false)
      const handleChangechk = event => {
        if (event.target.checked) {
          console.log('✅ Checkbox is checked');
        } else {
          console.log('⛔️ Checkbox is NOT checked');
        }
        setischkmodal(current => !current);
      };
      const handleModaleditsave=()=>{
        
        setShow3(false)
      }
  
     
      const [formdata,setfromdata]=useState({
        usersearch:""
      })
      
  
      // populatedata
      const [name,setname] = useState("")
      const [id,setid] = useState("")
      const [totalworkday,settotalworkday] = useState(0)
      const [totalpresentday,settotalpresentday] = useState(0)
      const [totalabsent,settotalabsent] = useState(0)
      const [totallate,settotallate] = useState(0)
      const [totalearlyleave,settotalearlyleave] = useState(0)
  
      const handleSearchclick =()=>{
         
          const foundItem = empwiseattApi.data.find(item => item.userid.toString() == formdata.usersearch);
  
          if (foundItem) {
            setidsave(true);
            setname(foundItem.name);
            setid(foundItem.id)
            settotalworkday(foundItem.totalworkday)
            settotalpresentday(foundItem.totalpresentday)
            settotalabsent(foundItem.totalabsent)
            settotallate(foundItem.totallate)
            settotalearlyleave(foundItem.totalearlyleave)
            console.log(foundItem.name);
          } else {
            setidsave(false);
          }
              
          
            mainfilter(formdata.usersearch?formdata.usersearch:"",activefrom,activeto,empwiseattApi.data) 
        
      }
     
  
      useEffect(()=>{
  
          
        
      },[formdata,name])
      
      
      const optionsparentmenu = [
        {
          id:1,
          opt:"Home1"
        },
        {
          id:2,
          opt:"Home2"
        },
      ]
      const [parentmenudrp,setparentmenudrp] = useState("")
      const drpfuncparentmenu=(parentmenydrpval,myid)=>{
        setparentmenudrp(parentmenydrpval)
      }
      const [menumodalimg,setmenumodalimg] = useState("")
      
      
    
    
    
    
    const handleInput = (e)=>{
      setfromdata({...formdata,[e.target.name]:e.target.value})
    }
  
    useEffect(()=>{
      console.log(empwiseattApi.data[0].punchdate)
    },[])
  return (
    <>
      <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
          <div className="mobilecontainer">
            <div className="adminmbheading">
              <h3>Employee Wise Attendance</h3>
            </div>
            <div className="admbwrap">
              <Row>
                <MobileInputSubComp col="6" name="User ID" direct="left">
                
                    <input type="number" name="usersearch" value={formdata.usersearch} onChange={handleInput}/>
                </MobileInputSubComp>
                <MobileInputSubComp name="Name" col="6" direct="right">
                     
                        
                        {
                          idsave==true?
                          <input type="text" value={name}/>
                          :
                          <input type="text" value=""/>

                        }
                </MobileInputSubComp>
                <MobileInputSubComp name="ID" col="12" direct="center">
               
                          {
                            idsave==true?
                            <input type="text" value={id}/>
                            :
                            <input type="text" value=""/>

                          }
                </MobileInputSubComp>
                <MobileInputSubComp col="6" name="Active From" direct="left">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activefrom}
                          onChange={(newvaldob)=>handleActiveFrom(newvaldob)}
                          renderInput={(params) => <TextField {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active From"
                            }} error={false} />}
                      />
                    </LocalizationProvider>
                </MobileInputSubComp>

                <MobileInputSubComp col="6" name="Active To" direct="right">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activeto}
                          onChange={(newvaldob)=>handleActiveTo(newvaldob)}
                          renderInput={(params) => <TextField {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active To"
                            }} error={false} />}
                      />
                    </LocalizationProvider>
                </MobileInputSubComp>
                <Col xs={10} className='m-auto mt-2'>
                    <Row>
                      <Col xs={6} className='pr5'>
                              <button className='cmbutton' onClick={handleSearchclick}>
                                  Search
                              </button>
                      </Col>
                      <Col xs={6} className='pl5'>
                              <button className='cmbutton' onClick={handleShow}> Print</button>
                      </Col>

                    </Row>
                </Col>
              </Row>
            </div>
            <div className="admbwrap">
              <div className="empwat">
              <Row style={{gap:"10px 0"}}>
                    <Col xs={6}>
                    <div className="item"><p>Total Work Day: {totalworkday}</p></div>
                    </Col>
                    <Col xs={6}>
                    <div className="item"><p>Total Present Day: {totalpresentday}</p></div>
                    </Col>
                    <Col xs={6}>
                    <div className="item"><p>Total Absent: {totalabsent}</p></div>
                    </Col>
                    <Col xs={6}>
                    <div className="item"><p>Total Late: {totallate}</p></div>
                    </Col>
                    <Col xs={6}>
                    <div className="item"><p>Total Early Leave: {totalearlyleave}</p></div>
                    </Col>
                  </Row> 
              </div>
            </div>
            <div className="admbwrap">
              <div className="tablewrapscroll">
              <div className="flexvaluetable empwisetable">
                    <table>
                      <thead>
                        <tr>
                            {
                              empwiseattApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            filteredArr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.punchdate}</td>
                                  <td>{item.shifttime}</td>
                                  <td>{item.intime}</td>
                                  <td>{item.outtime}</td>
                                  <td>{item.timelate}</td>
                                  <td>{item.type}</td>
                                </tr>
                              )
                            })
                            :
                            ""
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
              </div>
            </div>
            <div className="admbwrap">
                <Row>
                <Col lg={12} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={2}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffset+1} to {itemOffset+10} of {empwiseattApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
                </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EmployeeWiseAttendanceCompmb